import React from "react";

const TrackerAbout = () => {
  const brandCyan = "#0ea5e9";
  const brandPurple = "#d946ef";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Hero / Header Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                display: "block",
                textTransform: "uppercase",
              }}
            >
              ✦ LIVE GPS & SPEED MONITORING SYSTEM
            </span>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Real-Time Speed Tracking &{" "}
              <span style={{ color: brandPurple }}>Vehicle Security</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandCyan }}>Iconic Tracker</strong> garir
              real-time goti (speed), precise location, ebong engine status
              direct mobile o web app-e dekhanor jonno toiri kora ekti smart
              tracking solution.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "28px",
              }}
            >
              Over-speeding alert, harsh braking detection, engine remote lock,
              ebong route history replay-er madhyome apni apnar gari ba fleet-er
              shoroborchho nirapotta ebong shothik goti niontron nishchit korte
              parben.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {[
                "Live Speedometer & GPS Monitoring",
                "Instant Over-Speed Alert",
                "Remote Engine Control (On/Off)",
                "90 Days Travel History Replay",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandPurple,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <img
              src="https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=1200&q=85"
              alt="Vehicle Speed Tracking and GPS Dashboard"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                100%
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Accurate Speed & GPS
              </span>
            </div>
          </div>
        </div>

        {/* ================= 2. Key Vehicle Metrics Bar ================= */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            padding: "32px 24px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "Live Speed", label: "Real-time KM/H Monitor" },
            { value: "Instant Alert", label: "Over-speeding Warning" },
            { value: "Engine Lock", label: "Remote App Command" },
            { value: "24/7 Security", label: "Anti-Theft Protection" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "28px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. Speed & Vehicle Features Grid ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              SMART VEHICLE CONTROL
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Main Features of Our{" "}
              <span style={{ color: brandCyan }}>Vehicle Tracker</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "24px",
            }}
          >
            {[
              {
                title: "Live Speed Monitoring",
                desc: "Gari koshto kore kon rastay koto speed-e cholchhe ta mobile app-e continuous live gauge-e dekha jay.",
              },
              {
                title: "Speed Limit & Over-Speed Alert",
                desc: "Garithat nirdishto speed limit (e.g. 80 km/h) set kore rakhle, limit cross kora matro mobile-e push notification o push alert ashbe.",
              },
              {
                title: "Engine Remote Lock (Engine On/Off)",
                desc: "Aporadh ba churi shondeho hole app theke ek click-e garir engine bondho kore dewa jay.",
              },
              {
                title: "Geofence Boundary Alert",
                desc: "Map-e nirdishto elaka mark (Geofence) kore dile, gari sei elakar bahire gele ba dukhle instant alert ashbe.",
              },
              {
                title: "Trip & Speed History Replay",
                desc: "Goto 90 diner jekono tarikh-er gari kon rastay koto speed-e cholechhe ebong kothay kothay thamechhe ta replay kore dekha jay.",
              },
              {
                title: "Harsh Braking & Driving Behavior",
                desc: "Driver-er osthabhabik speed, sudden braking, ba dangerous driving track kore fleet-er nirapotta barano jay.",
              },
            ].map((service, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "26px 22px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.6",
                  }}
                >
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 4. Highlight Banner ================= */}
        <div
          style={{
            background: "#fdf4ff",
            border: "1px solid #f5d0fe",
            padding: "40px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "30px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              COMPLETE VEHICLE SAFETY
            </span>
            <h3
              style={{
                fontSize: "26px",
                fontWeight: "800",
                color: "#0f172a",
                margin: "8px 0 12px 0",
              }}
            >
              Control Your Vehicle From Anywhere
            </h3>
            <p
              style={{
                fontSize: "15px",
                color: "#475569",
                lineHeight: "1.65",
                margin: 0,
              }}
            >
              Gari nijosho hok ba business fleet—Iconic Tracker apnake dey shob
              rokom security analytics. Speed, mileage, engine hour, o live
              position janun ekei app theke.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            {[
              { title: "Speed Gauge", desc: "Realtime KM/H speedometer" },
              { title: "Mobile App", desc: "Android & iOS live tracking" },
              { title: "Engine Status", desc: "Accurate ACC On/Off tracking" },
              {
                title: "Fuel & Speed",
                desc: "Speed along with mileage report",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "18px 16px",
                  borderRadius: "10px",
                  border: "1px solid #fae8ff",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 4px 0",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: brandPurple,
                  }}
                >
                  {item.title}
                </h4>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    lineHeight: "1.4",
                    display: "block",
                  }}
                >
                  {item.desc}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Light CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #d946ef 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#fff",
              }}
            >
              Ensure Your Vehicle's Speed & Safety
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Get our advanced GPS tracking device installed and stay in control
              24/7.
            </p>
          </div>

          <button
            style={{
              background: "#ffffff",
              color: "#0f172a",
              border: "none",
              padding: "14px 28px",
              borderRadius: "8px",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            Get Tracker Device →
          </button>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default TrackerAbout;
